import React from 'react';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

const ArrowRightAlt = (props) => <ArrowRightAltIcon {...props} />;

export default ArrowRightAlt;
